import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Skeletor } from 'vue-skeletor';

createApp(App).use(router).component(Skeletor.name, Skeletor).mount('#app')
